module.exports = __webpack_public_path__ + "img/contact_map_background_lg.8b1045fb.png";